import { ChangeEvent } from 'react';

import Checkbox from '@components/checkbox/Checkbox';

import { CustomTableHeaderProps } from './types';

const CustomTableHeader = ({
  headers,
  hasMultiSelect = false,
  handleSelectAll,
  isAllRowSelected,
  isAllRowDisabled
}: {
  headers: CustomTableHeaderProps[];
  hasMultiSelect?: boolean;
  handleSelectAll?: (checked: boolean) => void;
  isAllRowSelected?: boolean;
  isAllRowDisabled?: boolean;
}) => (
  <div className="flex h-12.5 items-center justify-between truncate rounded-lg bg-cofeeGreyBlue100 p-4">
    {hasMultiSelect && (
      <div className="w-5">
        <Checkbox
          handleChange={(e: ChangeEvent<HTMLInputElement>) =>
            handleSelectAll?.(e.target.checked)
          }
          isChecked={isAllRowSelected && !isAllRowDisabled}
          checkIconUncheckedStyle="text-white fill-current opacity-100 border rounded-md border-borderGrey6"
          inputUnCheckedStyle="border-none"
          disabled={isAllRowDisabled}
        />
      </div>
    )}
    {headers.map((header) => (
      <div
        key={header.accessor}
        style={{ width: header.width }}
        className="px-2 text-sm font-medium text-cofeeNeutral10"
      >
        {header.Header}
      </div>
    ))}
  </div>
);

export default CustomTableHeader;
